import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AuthCallbackComponent implements OnInit {

  public error$: Observable<any> = this.auth.error$;

  constructor(private auth: AuthService, private router: Router) {
  }

  ngOnInit() {
    this.error$.subscribe(error => {
      console.error('Error Description:' + error.error_description);

      switch (error.error_description) {
        case 'email_not_verified':
          this.router.navigateByUrl('/auth-error/email-not-verified');
          break;
      }

      console.error(error);
    });
  }
}
